"use client";

import { BeehiveVariantProps } from "./props";
import { PlatformsImage } from "../../../core";
import Caroussel from "../../carroussel";
import { useState } from "react";

export default function ShowroomGridVariant({
  openLightboxOnSlide,
  vehicleImagesThumb,
  vehicle,
  vehicleImagesLarge,
}: BeehiveVariantProps) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedImage, setSelectedImage] = useState<{
    href: string;
    index: number;
  }>(() => ({
    href: vehicleImagesThumb[0],
    index: 0,
  }));

  const images = vehicleImagesThumb.slice(0, 5);

  return (
    <div className="w-full max-w-7xl mx-auto p-4">
      <div className="gap-4 pt-10 hidden sm:grid">
        <div>
          <PlatformsImage
            width={1000}
            height={500}
            onClick={() =>
              openLightboxOnSlide(
                vehicleImagesThumb.length > selectedImage.index
                  ? selectedImage.index + 1
                  : 1
              )
            }
            src={vehicleImagesLarge[0]}
            // src={
            //   "https://cdn-images.sync.com.br/1440x1080/50d0a0b1-1db1-429d-93e2-feffeb911d18.JPG"
            // }
            alt={`Imagem exterior do veículo ${vehicle.model} ${vehicle.modelYear} ${vehicle.version}`}
            preload={true}
            priority={true}
            className="w-full h-auto max-h-[600px] object-cover rounded-lg"
          />
        </div>
        <div className="grid grid-cols-5 gap-4 items-center">
          {images.map((image, idx) => (
            <div key={idx}>
              <PlatformsImage
                width={600}
                height={500}
                onClick={() => openLightboxOnSlide(idx + 2)}
                src={image}
                alt={`Imagem exterior do veículo ${vehicle.model} ${vehicle.modelYear} ${vehicle.version}`}
                className="h-auto max-w-full rounded-lg cursor-pointer"
              />
            </div>
          ))}
        </div>
      </div>

      <div className="sm:hidden mt-4">
        <Caroussel
          itemsPerView="1"
          itens={images.map((i, idx) => (
            <PlatformsImage
              key={idx}
              width={600}
              height={500}
              onClick={() => openLightboxOnSlide(idx + 1)}
              src={vehicleImagesThumb[idx]}
              alt={`Imagem exterior do veículo ${vehicle.model} ${vehicle.modelYear} ${vehicle.version}`}
              className="w-full h-auto object-cover rounded-lg"
              preload={idx < 1}
              priority={idx < 1}
            />
          ))}
        />
      </div>
    </div>
  );
}
